import { globalVars } from "./variables";
import { getConsentCategories, initiatePageViewTracking } from "./helperFunctions";
import { initHomePageTracking } from "./homePageTracking";
import { initContentPageTracking } from "./contentPageTracking";
import { initFooterTracking } from "./footerTracking";
import { initHeaderTracking } from "./headerTracking";
import { initFaqTracking } from "./faqTracking";

import {
    addToGlobalContexts,
} from "@rtl_nl/rtl-snowplow";

export default class snowplow {
    constructor() {
        this.initSnowplow();
    }

    async initSnowplow() {

        /**
         * add rtl_platform and rtl_consent to global context on init,
         * since they are the same through the whole site
         */
        await addToGlobalContexts({
            rtlConsent: {
                tcConsentLevel: getConsentCategories().toString(),
                tcSource: 'OneTrust',
                tcVersion: 'TCFv2',
            },
            rtlPlatform: {
                pageName: globalVars.page_name,
                platformName: globalVars.platform,
                language: globalVars.language,
                environment: globalVars.env,
                brandName: 'videoland'
            },
            enableExperimentalData: true,
            appId: globalVars.app_id
        });
        /*
        add general trackers
            page views
            header
            footer
            FAQs
        */
        initiatePageViewTracking();
        initHeaderTracking();
        initFooterTracking();
        initFaqTracking();

        /*
        add trackers from right page type
            home
            title
        */
        if (globalVars.page_name == 'videoland.onboarding.home') {
            initHomePageTracking();
        } else if (globalVars.page_name.indexOf('titles') > -1) {
            initContentPageTracking('titlePage');
        } else {
            initContentPageTracking('contentPage');
        }
    }
}
